import React from "react";
import translate from "../../../../i18n/translate";
import { useNavigate } from 'react-router-dom';
import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import "./LearnersIntercept.scss";

const LearnersIntercept = () => {
  const navigate = useNavigate();
  const marketingUrl = process.env.REACT_APP_PRIVACY_POLICY_URL?.split('/en')[0];

  const handleSkipClick = () => {
    let interceptLearner: any = sessionStorage.getItem('learnersintercept');
    let isInterceptClosed = JSON.parse(interceptLearner);
    isInterceptClosed.islearnersintercept = false;
    sessionStorage.setItem('learnersintercept', JSON.stringify(isInterceptClosed));
    navigate("/");
  }

  return (
    <div className="intercept-container">
      <div className="intercept-profile-container">
        <div className="intercept-profile-form-container">
          <div className="intercept-close-button">
            <IconButton aria-label="delete" color="primary" onClick={handleSkipClick} >
              <CloseIcon className="close-icon"></CloseIcon>
            </IconButton>
          </div>
          <div className="intercept-layout">
            <h3 className="intercept-title">{translate("learners_intercept_title")}</h3>
            <div className="intercept-form-row">
              <img src={window.location.origin + "/images/" + "Feature_Illustrations/Solo-learner.svg"} width={"240"} alt="flag" ></img>
              <div className="intercept-body">
                <p>
                  {translate("learners_intercept_text1")} 
                  <strong>{process.env.REACT_APP_SSO_LOGIN + "/cglearning. "}</strong>
                  {translate("learners_intercept_text2")} 
                  <a href={`${marketingUrl}`}>{marketingUrl + ". "}</a> 
                  {translate("learners_intercept_text3")}
                </p>
                <p>
                  {translate("learners_intercept_text4")} 
                  <a href={process.env.REACT_APP_GE_SUPPORT_URL}>{process.env.REACT_APP_GE_SUPPORT_URL + "."}</a> 
                </p>
              </div>           
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnersIntercept;
